import api from '../../../services/api';
import {
  normalizeInventory,
  normalizeMonthlyInventoryReport,
  normalizeInventoryVariantDetail,
  type InventoryVariantDetailDto,
  type MonthlyInventoryReport,
} from '../../../dto/inventory';
import type { Inventory } from '../../../types/pz';

export async function fetchInventoryList(): Promise<Inventory[]> {
  const response = await api.get('/inventory?includeVariant=true');
  if (!Array.isArray(response.data)) {
    throw new Error('Invalid inventory list response');
  }
  return response.data.map((row, index) => normalizeInventory(row, `inventory[${index}]`));
}

export async function fetchMonthlyInventoryReport(
  year: number,
  month: number,
): Promise<MonthlyInventoryReport> {
  const response = await api.get('/inventory/reports/monthly', {
    params: { year, month },
  });
  return normalizeMonthlyInventoryReport(response.data);
}

export async function fetchInventoryVariantDetail(
  variantId: string,
): Promise<InventoryVariantDetailDto> {
  const response = await api.get(`/inventory/variant/${variantId}`);
  const detail = normalizeInventoryVariantDetail(response.data);

  if (!detail.batchesLoaded || !detail.recentMovementsLoaded) {
    throw new Error('Incomplete inventory variant detail response');
  }

  return detail;
}
